import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { LOGIN_URL } from "../service/data";

const initialState = {
  userInfo: {},
  userLoading: false,
  userError: null,
  userSuccess: false,
  accessToken: "",
  userStatus: null,
  role: "",
  userLoggedIn: false,
};

export const LoginUser = createAsyncThunk(
  "user/LoginUser",
  async ({ email, access_token }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          Authorization: access_token ? `Bearer ${access_token}` : "",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Methods": "*",
        },
      };
      const { data } = await axios.post(
        `${LOGIN_URL}`,
        { email, access_token },
        config
      );
     
     
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) {
        return rejectWithValue(error.response.status);
      }
      if (error.message && error.message === "Network Error") {
        return rejectWithValue(error.message);
      }
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserInfo: (state, { payload }) => {
      state.userInfo = payload;
    },
    setAccessToken: (state, { payload }) => {
      state.accessToken = payload;
    },
    setUserSuccess: (state)=>
    {
     state.userSuccess =  true;
    },
    logout: (state) => {
      state.userLoading = false;
      state.userSuccess = false;
      state.userInfo = null;
      state.userError = null;
    },
  },
  extraReducers: {
    [LoginUser.pending]: (state) => {
      state.userLoading = true;
      state.userSuccess = false;
      state.userError = null;
    },
    [LoginUser.fulfilled]: (state, { payload }) => {
      sessionStorage.setItem('user',payload.role);
      state.userLoading = false;
      state.userSuccess = true;
      state.userInfo = payload;
      state.role = payload.role;
      state.userLoggedIn = true;
    },
    [LoginUser.rejected]: (state, { payload }) => {
      state.userLoading = false;
      state.userError = payload;
    },
  },
});


export const { logout, setAccessToken,setUserSuccess,setUserInfo } = userSlice.actions;

export default userSlice.reducer;
